// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3v2yg","content":"styles_content__19Vlb","checkbox":"styles_checkbox__1qa6E","checkboxLabel":"styles_checkboxLabel__1aLUc"};